import { img2, img3, img4, img5, img6, img7, img8, img9 } from "../../_components/Imagepath";

export default {
    Data: [
        {
          Id: 1,
          key:1,
          Name: "John Smith",
          Email: "john@example.com",
          Img:img2,
          Payment: "#25689825",
          Amount: "$1,54,220",
          date: "19 Dec 2022, 06:12 PM",
          PaymentMethod: "Cash",
          Status: "Paid",
          Action: ""
        },
        {
          Id: 2,
          key:2,
          Name: "Johnny",
          Email:"johnny@example.com",
          Img: img3,
          Payment: "#25689826",
          Amount: "$1,222",
          date: "19 Dec 2022, 06:12 PM",
          PaymentMethod: "Cheque",
          Status: "Pending",
          Action: ""
        },
        {
          Id: 3,
          key:3,
          Name: "Robert",
          Email:"robert@example.com",
          Img: img4,
          Payment: "#25689827",
          Amount: "$2,2222",
          date: "19 Dec 2022, 06:12 PM",
          PaymentMethod: "Cheque",
          Status: "Partially Paid",
          Action: ""
        },
        {
          Id: 4,
          key:4,
          Name: "Sharonda",
          Email:"sharon@example.com",
          Img: img5,
          Payment: "#25689828",
          Amount: "$5,222",
          date: "19 Dec 2022, 06:12 PM",
          PaymentMethod: "Cash",
          Status: "Pending",
          Action: ""
        },
        {
          Id: 5,
          key:5,
          Name: "Randall",
          Email: "randall@example.com",
          Img: img7,
          Payment: "#25689829",
          Amount: "$8,54,220",
          date: "19 Dec 2022, 06:12 PM",
          PaymentMethod: "Cheque",
          Status: "Paid",
          Action: ""
        },
        {
          Id: 6,
          key:6,
          Name: "Pricilla",
          Email:"pricilla@example.com",
          Img: img6,
          Payment: "#25689830",
          Amount: "$3,54,220",
          date: "19 Dec 2022, 06:12 PM",
          PaymentMethod: "Cheque",
          Status: "Paid",
          Action: ""
        },
        {
          Id: 7,
          key:7,
          Name: "Johnny Smith",
          Email:"johnnysmith@example.com",
          Img: img7,
          Payment: "#25689831",
          Amount: "$1,54,220",
          date: "19 Dec 2022, 06:12 PM",
          PaymentMethod: "Cash",
          Status: "Paid",
          Action: ""
        },
        {
          Id: 8,
          key:8,
          Name: "Johnny",
          Email:"johnny@example.com",
          Img: img8,
          Payment: "#25689832",
          Amount: "$1,222",
          date: "19 Dec 2022, 06:12 PM",
          PaymentMethod: "Cheque",
          Status: "Pending",
          Action: ""
        },
        {
          Id: 9,
          key:9,
          Name: "Sharonda",
          Email:"sharonda@example.com",
          Img: img9,
          Payment: "#25689833",
          Amount: "$2,2222",
          date: "19 Dec 2022, 06:12 PM",
          PaymentMethod: "Cheque",
          Status: "Partially Paid",
          Action: ""
        }
       ]
}